/* eslint-disable @typescript-eslint/prefer-regexp-exec */
/* eslint-disable no-bitwise */

export default function isLightColor(color: string): boolean {
  let r: number | string;
  let g: number | string;
  let b: number | string;
  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    const arrColor = color.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
    ) as RegExpMatchArray;

    r = arrColor[1];
    g = arrColor[2];
    b = arrColor[3];
  } else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    const colorStr = +(
      "0x" +
      color.slice(1).replace((color.length < 5 && /./g) as RegExp, "$&$&")
    );

    r = colorStr >> 16;
    g = (colorStr >> 8) & 255;
    b = colorStr & 255;
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(
    0.299 * (Number(r) * Number(r)) +
      0.587 * (Number(g) * Number(g)) +
      0.114 * (Number(b) * Number(b))
  );

  return hsp > 217.5;
}
